export default {
  // 已有文本
  'pages.dashboard.text': '無縫接入門店管理生態，提供遠程積分管理解決方案。',
  'pages.dashboard.storeTitle': '門店',
  'pages.dashboard.management.title': '總部管理',

  // 二维码相关
  'pages.dashboard.tooltip.qrcode': '顯示會員註冊二維碼',
  'pages.dashboard.qrcode.title': '會員註冊二維碼',
  'pages.dashboard.qrcode.download': '下載二維碼',
  'pages.dashboard.qrcode.close': '關閉',

  // 其他已有文本
  'pages.dashboard.tooltip.members': '會員管理',
  'pages.dashboard.tooltip.cards': '禮品卡',
  'pages.dashboard.tooltip.coupons': '優惠券',
  'pages.dashboard.tooltip.orders': '訂單',

  'pages.dashboard.userApp.management.title': '用戶 App 管理',
  'pages.dashboard.userApp.posters.button': '內容管理',
  'pages.dashboard.userApp.posters.title': '內容管理',
  'pages.dashboard.userApp.posters.add': '新增海報',
  'pages.dashboard.userApp.posters.edit': '編輯海報',
  'pages.dashboard.userApp.posters.noPermission.title': '無權限',
  'pages.dashboard.userApp.posters.noPermission.subTitle':
    '你無權訪問該總部的用戶 App 宣傳海報管理。',
  'pages.dashboard.userApp.posters.upload.imageTypeError': '只能上傳 jpg、png 或 webp 圖片',
  'pages.dashboard.userApp.posters.upload.sizeError': '圖片不能超過 5MB',
  'pages.dashboard.userApp.posters.message.uploadRequired': '請上傳海報圖片',
  'pages.dashboard.userApp.posters.message.saveSuccess': '保存成功',
  'pages.dashboard.userApp.posters.message.deleteSuccess': '刪除成功',
  'pages.dashboard.userApp.posters.empty.all': '暫無海報',
  'pages.dashboard.userApp.posters.empty.carousel': '暫無頂部滾動海報',
  'pages.dashboard.userApp.posters.empty.static': '暫無靜態海報',
  'pages.dashboard.userApp.posters.delete.confirm': '確認刪除這張海報？',
  'pages.dashboard.userApp.posters.delete.ok': '刪除',
  'pages.dashboard.userApp.posters.delete.cancel': '取消',
  'pages.dashboard.userApp.posters.type.carousel': '滾動翻頁海報',
  'pages.dashboard.userApp.posters.type.static': '靜態海報',
  'pages.dashboard.userApp.posters.sort': '排序',
  'pages.dashboard.userApp.posters.section.carousel': '頂部滾動海報',
  'pages.dashboard.userApp.posters.section.static': '靜態海報',
  'pages.dashboard.userApp.posters.form.title': '海報標題',
  'pages.dashboard.userApp.posters.form.title.required': '請輸入海報標題',
  'pages.dashboard.userApp.posters.form.title.placeholder': '例如：週末狂歡購',
  'pages.dashboard.userApp.posters.form.displayType': '海報類型',
  'pages.dashboard.userApp.posters.form.displayType.required': '請選擇海報類型',
  'pages.dashboard.userApp.posters.form.displayType.carousel':
    '滾動翻頁海報（頂部自動輪播，建議 1536 x 860）',
  'pages.dashboard.userApp.posters.form.displayType.static':
    '靜態海報（下方列表，建議 1536 x 560）',
  'pages.dashboard.userApp.posters.form.sortOrder': '滾動順序',
  'pages.dashboard.userApp.posters.form.sortOrder.required': '請選擇滾動順序',
  'pages.dashboard.userApp.posters.form.sortOrder.page': '第 {value} 頁',
  'pages.dashboard.userApp.posters.form.image': '海報圖片',
  'pages.dashboard.userApp.posters.form.image.replace': '替換圖片（可選）',
  'pages.dashboard.userApp.posters.form.image.select': '選擇圖片',
  'pages.dashboard.userApp.posters.scope.common': '通用海報',
  'pages.dashboard.userApp.posters.scope.store': '門店海報',
  'pages.dashboard.userApp.posters.store.placeholder': '請選擇門店',
  'pages.dashboard.userApp.posters.store.viewOnly': '僅可查看——需要門店海報管理權限',
  'pages.dashboard.userApp.catalog.tab': '目錄',
  'pages.dashboard.userApp.catalog.current': '目前目錄',
  'pages.dashboard.userApp.catalog.none': '尚未發布目錄',
  'pages.dashboard.userApp.catalog.replace': '替換目錄',
  'pages.dashboard.userApp.catalog.upload': '上傳目錄',
  'pages.dashboard.userApp.catalog.title': '標題',
  'pages.dashboard.userApp.catalog.dates': '展示日期和時間（雪梨時間）',
  'pages.dashboard.userApp.catalog.pdf': 'PDF 檔案',
  'pages.dashboard.userApp.catalog.select': '選擇 PDF',
  'pages.dashboard.userApp.catalog.entryImage': '目錄入口封面圖',
  'pages.dashboard.userApp.catalog.entryImageHint': '建議尺寸：1200 × 360 px。',
  'pages.dashboard.userApp.catalog.selectImage': '選擇圖片',
  'pages.dashboard.userApp.catalog.invalidImage': '請選擇不超過 20 MB 的 JPG、PNG 或 WebP 圖片',
  'pages.dashboard.userApp.catalog.publish': '發布目錄',
  'pages.dashboard.userApp.catalog.replacePublish': '替換並發布',
  'pages.dashboard.userApp.catalog.delete': '刪除',
  'pages.dashboard.userApp.catalog.confirm': '確認刪除該目錄？',
  'pages.dashboard.userApp.catalog.open': '開啟 PDF',
  'pages.dashboard.userApp.catalog.pages': '{count} 頁',
  'pages.dashboard.userApp.catalog.processing': '正在處理目錄 {done} / {total} 頁',
  'pages.dashboard.userApp.catalog.failed': '處理失敗：{error}',
  'pages.dashboard.userApp.catalog.issues': '已排期目錄',
  'pages.dashboard.userApp.catalog.active': '展示中',
  'pages.dashboard.userApp.catalog.edit': '編輯',
  'pages.dashboard.userApp.catalog.save': '儲存',
  'pages.dashboard.userApp.catalog.saved': '目錄已儲存',
  'pages.dashboard.userApp.catalog.removed': '目錄已刪除',
  'pages.dashboard.userApp.catalog.queued': '目錄正在處理',
  'pages.dashboard.userApp.catalog.required': '請填寫標題並選擇 PDF 和封面圖',
  'pages.dashboard.userApp.catalog.invalidPeriod': '請選擇有效的開始和結束日期時間',
  'pages.dashboard.userApp.catalog.invalidPdf': '請選擇不超過 30 MB 的 PDF',
  'pages.dashboard.userApp.catalog.loadFailed': '無法載入目錄',
  'pages.dashboard.userApp.catalog.uploadFailed': '目錄上傳失敗',
  'pages.dashboard.userApp.catalog.saveFailed': '無法儲存目錄',
  'pages.dashboard.userApp.catalog.removeFailed': '無法移除目錄',
};
